/** @jsx jsx */
import { css, jsx } from '@emotion/core';

interface SquareProps {
  handleTouch: () => void;
  color: string;
  width: number;
  height: number;
  top: number;
  left: number;
}

export const Square = (props: SquareProps) => {
  return (
    <div
      css={
        css`
          background-color: ${props.color};
          width: ${props.width}px;
          height: ${props.height}px;
          position: absolute;
          top: ${props.top}px;
          left: ${props.left}px;
          animation: App-logo-spin infinite 20s linear;

          @keyframes App-logo-spin {
            from {
            transform: rotate(0deg);
            }
            to {
            transform: rotate(360deg);
            }
          }
        `
      }
      onMouseEnter={props.handleTouch}
    ></div>
  );
};
